import { render } from "./EmailOtpVerify.vue?vue&type=template&id=5c06c482&scoped=true"
import script from "./EmailOtpVerify.vue?vue&type=script&lang=js"
export * from "./EmailOtpVerify.vue?vue&type=script&lang=js"

import "./EmailOtpVerify.vue?vue&type=style&index=0&id=5c06c482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c06c482"]])

export default __exports__